"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useNotifications = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _recoil = require("recoil");

var _notification = _interopRequireDefault(require("./notification"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var notificationState = (0, _recoil.atom)({
  key: 'notificationState',
  "default": null
});

var useNotifications = function useNotifications(notification) {
  var setNotification = (0, _recoil.useSetRecoilState)(notificationState);
  var resetNotificationStates = (0, _recoil.useResetRecoilState)(notificationState);

  var showNotification = _react["default"].useCallback(function (notification) {
    if ((notification === null || notification === void 0 ? void 0 : notification.type) && ['primary', 'error'].indexOf(notification.type) === -1) {
      throw new Error('type needs to be one of error or primary');
    }

    if ((notification === null || notification === void 0 ? void 0 : notification.content) && (notification === null || notification === void 0 ? void 0 : notification.type)) {
      setNotification([notification]);
    } else {
      throw new Error('missing notification properties');
    }
  }, [notification, setNotification]);

  return {
    showNotification: showNotification,
    resetNotificationStates: resetNotificationStates
  };
};

exports.useNotifications = useNotifications;

var Notifications = function Notifications() {
  var notifications = (0, _recoil.useRecoilValue)(notificationState);

  if (!notifications) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notifications.map(function (note) {
    return _objectSpread(_objectSpread({}, note), {}, {
      message: note.content
    });
  }).map(function (notification, index) {
    return /*#__PURE__*/_react["default"].createElement(_notification["default"], (0, _extends2["default"])({
      key: index
    }, notification));
  }));
};

var _default = Notifications;
exports["default"] = _default;